exports = module.exports = require("../../../node_modules/@zxcabs/rtl-css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".tooltip{margin:10px;display:grid;grid-template-columns:1fr 1fr}.tooltip__min{text-align:start}.tooltip__max{text-align:end}", ""]);

// exports
